import type { UserRequirementStateStatus } from '@capsicum/common';

export const enum Regulation {
	International = 'international',
	RequiresConfirmation = 'confirmation',
	Usa = 'usa'
}

export const ITALIAN_COUNTRY = 'Italia';

export const PROOF_OF_ADDRESS_UPLOAD_PROPS = {
	maxSize: 20 * 1000 * 1000,
	selectionLimit: 5
};

export const SOI_MAX_FILE_SIZE = 10 * 1000 * 1000;

export const TRAVEL_RULE_POI_ALLOWED_STATUSES = [
	'completed_allow',
	'under_review',
	'waiting'
] as Array<UserRequirementStateStatus>;

export const FORCED_TOP_UP_REQUIREMENTS_ERROR_CODE = '1aa38110-a3a0-4c6b-b3cd-a255ab817c99';
